<template>
  <div v-if="application.applicationFile"
       class="pt-4 pb-10">
    <Loader v-if="loading" class="my-5"/>
    <div v-else class="docs__pdf w-full">
      <iframe
          :src="applicationPdfFile"
          allowfullscreen
          height="100%"
          width="100%"
      ></iframe>
    </div>
  </div>
</template>
<script>
import applicationApi from "../../../api/employee/application";

export default {
  props: {
    application: Object
  },
  data() {
    return {
      loading: false,
      applicationPdfFile: null,
    }
  },
  created() {
    if(this.application.applicationFile) {
      this.getFile()
    }
  },
  methods: {
    getFile() {
      this.loading = true
      applicationApi
          .getApplicationFile(this.application.id, this.application.applicationFile.id)
          .then(({ data }) => {
            this.applicationPdfFile = `data:application/pdf;base64,${data.base64}`
          })
          .catch((error) => {
            this.$snotify.error(error)
          }).finally(() => {
        this.loading = false
      })
    },
  }
}
</script>